import React from 'react';
import './LessonHero.css';

/**
 * Full-bleed image band that opens a page.
 *
 * Used by the lesson shell and by the activity listing pages, so a grammar
 * index and a grammar lesson open with the same image, title and intro.
 *
 * title       - required heading
 * image       - backdrop photo; omitted pages get a flat gradient band
 * description - short intro under the title
 * level       - optional level code shown in the eyebrow, e.g. "B2"
 * eyebrow     - optional short category word; the eyebrow row only renders
 *               when one of level/eyebrow is set
 *
 * The image URL is passed through a custom property so the styling stays in
 * the stylesheet, and the band carries role="img" with the title as its label
 * because the photo is now decorative text backdrop rather than content.
 */
const LessonHero = ({ title, image, description, level, eyebrow }) => {
  const showEyebrow = Boolean(level || eyebrow);

  return (
    <header
      className={`lesson-hero${image ? '' : ' lesson-hero--no-image'}`}
      style={image ? { '--lesson-hero-image': `url("${image}")` } : undefined}
      role={image ? 'img' : undefined}
      aria-label={image ? title : undefined}
    >
      <div className="lesson-hero__inner">
        {showEyebrow && (
          <p className="lesson-hero__eyebrow">
            {level}
            {level && eyebrow && (
              <span className="lesson-hero__eyebrow-dot" aria-hidden="true">·</span>
            )}
            {eyebrow}
          </p>
        )}
        <h1 className="lesson-hero__title">{title}</h1>
        {description && <p className="lesson-hero__desc">{description}</p>}
      </div>
    </header>
  );
};

export default LessonHero;